// Generated from the shared app source. Do not edit.
/* eslint-disable no-whitespace-before-property */
export const PYTHAGOREAN_VALUES = Object.freeze({
  A: 1,
  B: 2,
  C: 3,
  D: 4,
  E: 5,
  F: 6,
  G: 7,
  H: 8,
  I: 9,
  J: 1,
  K: 2,
  L: 3,
  M: 4,
  N: 5,
  O: 6,
  P: 7,
  Q: 8,
  R: 9,
  S: 1,
  T: 2,
  U: 3,
  V: 4,
  W: 5,
  X: 6,
  Y: 7,
  Z: 8,
}         );




export const DEFAULT_IGNORED_PREPOSITIONS = Object.freeze([
  'DE',
  'DA',
  'DO',
  'DAS',
  'DOS',
  'OF',
  'VON',
  'VOM',
  'ZU',
  'ZUM',
  'ZUR',
]         );

export const DEFAULT_IGNORED_PREPOSITION_SEQUENCES = Object.freeze([
  'VON DER',
  'VON DEN',
  'VON DEM',
]         );







































const VOWELS = new Set                   (['A', 'E', 'I', 'O', 'U']);

export function normalizeName(input        )         {
  return input
    .normalize('NFKD')
    .replace(/\p{M}+/gu, '')
    .toUpperCase()
    .replace(/['’ʻʼʹ＇\p{Dash_Punctuation}]+/gu, '')
    .replace(/[^A-Z]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

export function matchNamePrepositions(
  input        ,
  prepositions                    = [
    ...DEFAULT_IGNORED_PREPOSITION_SEQUENCES,
    ...DEFAULT_IGNORED_PREPOSITIONS,
  ],
)                                  {
  const sourceNormalized = normalizeName(input);
  const sourceParts = sourceNormalized === '' ? [] : sourceNormalized.split(' ');
  const patterns = prepositions
    .map((preposition) => normalizeName(preposition).split(' ').filter(Boolean))
    .filter((pattern) => pattern.length > 0)
    .sort((left, right) => right.length - left.length);
  const matches                         = [];

  for (let partIndex = 0; partIndex < sourceParts.length; ) {
    const pattern = patterns.find((candidate) =>
      candidate.every(
        (part, patternIndex) => sourceParts[partIndex + patternIndex] === part,
      ),
    );

    if (pattern === undefined) {
      partIndex += 1;
      continue;
    }

    const endPartIndex = partIndex + pattern.length - 1;
    const text = pattern.join(' ');
    matches.push({
      key: `${partIndex}:${endPartIndex}:${text}`,
      text,
      parts: pattern,
      startPartIndex: partIndex,
      endPartIndex,
    });
    partIndex = endPartIndex + 1;
  }

  const ignoredPartCount = matches.reduce(
    (total, match) => total + match.parts.length,
    0,
  );

  return ignoredPartCount === sourceParts.length ? [] : matches;
}

export function analyzeName(
  input        ,
  options                     = {},
)               {
  const sourceNormalized = normalizeName(input);
  const sourceParts = sourceNormalized === '' ? [] : sourceNormalized.split(' ');
  const restoredMatchKeys = new Set(options.restoredPrepositionMatchKeys ?? []);
  const ignoredPrepositionMatches = matchNamePrepositions(
    sourceNormalized,
    options.ignoredPrepositions,
  ).filter((match) => !restoredMatchKeys.has(match.key));
  const ignoredPartIndexes = new Set(
    ignoredPrepositionMatches.flatMap((match) => {
      const indexes           = [];
      for (let index = match.startPartIndex; index <= match.endPartIndex; index += 1) {
        indexes.push(index);
      }
      return indexes;
    }),
  );
  const ignoredParts = sourceParts.filter((_, index) => ignoredPartIndexes.has(index));
  const parts = sourceParts.filter((_, index) => !ignoredPartIndexes.has(index));
  const yCount = parts.reduce(
    (total, part) => total + [...part].filter((letter) => letter === 'Y').length,
    0,
  );
  const yClassifications = options.yClassifications ?? [];

  if (yClassifications.length !== yCount) {
    throw new RangeError(
      `Expected ${yCount} phonetic Y classifications, received ${yClassifications.length}.`,
    );
  }

  if (yClassifications.some((kind) => kind !== 'vowel' && kind !== 'consonant')) {
    throw new RangeError('Each Y must be classified as vowel or consonant.');
  }

  const characters                          = [];
  const frequencies = new Array        (9).fill(0);
  let yIndex = 0;

  parts.forEach((part, partIndex) => {
    for (const [indexInPart, rawLetter] of [...part].entries()) {
      const letter = rawLetter                     ;
      const value = PYTHAGOREAN_VALUES[letter];
      const kind =
        letter === 'Y'
          ? yClassifications[yIndex++]
          : VOWELS.has(letter)
            ? 'vowel'
            : 'consonant';

      characters.push({ letter, value, kind, partIndex, indexInPart });
      frequencies[value - 1] = (frequencies[value - 1] ?? 0) + 1;
    }
  });

  const total = characters.reduce((sum, character) => sum + character.value, 0);
  const vowelTotal = characters
    .filter((character) => character.kind === 'vowel')
    .reduce((sum, character) => sum + character.value, 0);

  return {
    sourceNormalized,
    normalized: parts.join(' '),
    parts,
    ignoredParts,
    ignoredPrepositionMatches,
    characters,
    total,
    vowelTotal,
    consonantTotal: total - vowelTotal,
    frequencies,
  };
}
